<template>
  <div class="big flag-record">
    <div class="page_title">锦旗记录</div>
    <div class="container" style="padding: 20px">
      <el-tabs v-model="searchForm.settlement_status" @tab-click="seachEnterFun">
        <el-tab-pane
          label="全部"
          name="0"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1892') : false
          "
        ></el-tab-pane>
        <el-tab-pane
          label="待系统核算"
          name="1"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1900') : false
          "
        ></el-tab-pane>
        <el-tab-pane
          label="待结算"
          name="2"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1900') : false
          "
        ></el-tab-pane>
        <el-tab-pane
          label="已结算"
          name="3"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1900') : false
          "
        ></el-tab-pane>
      </el-tabs>
      <!-- 搜索栏 -->
      <div class="search-box">
        <!-- 医生姓名 -->
        <div class="item">
          <span style="margin-left: 10px">医生姓名</span>
          <el-input
            v-model="searchForm.doctor_name"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>
        <!-- 医生手机号 -->
        <div class="item">
          <span style="margin-left: 10px">医生手机号</span>
          <el-input
            v-model="searchForm.doctor_phone"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 用户手机号 -->
        <div class="item">
          <span style="margin-left: 10px">用户手机号</span>
          <el-input
            v-model="searchForm.user_phone"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 交易单号 -->
        <div class="item">
          <span style="margin-left: 10px">交易单号</span>
          <el-input
            v-model="searchForm.trade_no"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 赠送金额 -->
        <div class="item">
          <span style="margin-left: 10px">赠送金额</span>
          <el-select
            v-model="searchForm.item_id"
            clearable
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="(item, index) in itemIdOption"
              :key="index"
              :label="item.money"
              :value="item.item_id"
            ></el-option>
          </el-select>
        </div>

        <!-- 支付时间 -->
        <div class="item">
          <span style="margin-left: 10px">支付时间</span>
          <el-date-picker
            v-model="searchForm.pay_time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 230px"
            @change="getList"
          ></el-date-picker>
        </div>

        <!-- 是否测试医生 -->
        <div class="item">
          <span style="margin-left: 10px">是否测试医生</span>
          <el-radio-group
            v-model="searchForm.is_test"
            size="small"
            style="padding-top: 4px"
            @change="getList"
          >
            <el-radio :label="2">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>

        <!-- 购买次数 -->
        <div class="item">
          <span style="margin-left: 10px">购买次数：{{ info.buy_time }}次</span>
          <span style="margin-left: 10px">购买用户：{{ info.buy_user }}人</span>
          <span style="margin-left: 10px">总计：{{ info.buy_money }}元</span>

          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="seachEnterFun"
            >查询</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="dark"
          ref="multipleTable"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :sortable="item.sortable"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'pay_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>

              <div v-else-if="item.prop == 'settlement_status'">
                {{ scope.row[item.prop] | settlement_statusText }}
              </div>

              <div v-else-if="item.prop == 'is_recommend'">
                {{ scope.row[item.prop] == 1 ? "是" : "否" }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="lookBtn(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1903') : false
                "
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
    <!-- 详情弹框 -->
    <el-dialog
      title="奖励详情"
      :visible.sync="detailsVisible"
      width="800px"
      custom-class="flag-record-dia"
    >
      <div style="padding: 10px">
        <div class="user-info">
          <div class="item">
            <div class="title">
              <span>用户昵称</span>
              <span>{{ detailsInfo.nick_name }}</span>
            </div>

            <div class="title">
              <span>手机号</span>
              <span>{{ detailsInfo.user_phone }}</span>
            </div>
          </div>

          <div class="item">
            <div class="title">
              <span>赠送人姓名</span>
              <span>{{ detailsInfo.user_name }}</span>
            </div>

            <div class="title">
              <span>性别</span>
              <span>{{ detailsInfo.sex | sexText }}</span>
            </div>

            <div class="title">
              <span>年龄</span>
              <span>{{ detailsInfo.age_str }}</span>
            </div>
          </div>

          <div class="item">
            <div class="title">
              <span>医生姓名</span>
              <span>{{ detailsInfo.doctor_name }}</span>
            </div>

            <div class="title">
              <span>职称</span>
              <span>{{ detailsInfo.title }}</span>
            </div>

            <div class="title">
              <span>手机号</span>
              <span>{{ detailsInfo.doctor_phone }}</span>
            </div>
          </div>
        </div>
        <el-divider content-position="left">锦旗信息</el-divider>
        <div class="flag-info">
          <div class="item">
            <div class="title">
              <span>锦旗类型</span>
              <span>{{ detailsInfo.silk_banner_title }}</span>
            </div>
          </div>
          <div class="item">
            <div class="title">
              <span>金额</span>
              <span>{{ detailsInfo.pay_money }}</span>
            </div>
          </div>

          <!-- <div class="item">
            <div class="title">
              <span>关联处方/问诊</span>
              <span>宋大雷</span>
            </div>
          </div> -->

          <div class="item">
            <div class="title">
              <span>赠言</span>
              <span>{{ detailsInfo.dedication }}</span>
            </div>
          </div>
        </div>
        <el-divider content-position="left">支付信息</el-divider>
        <div class="pay-info">
          <div class="item">
            <div class="title">
              <span>支付时间</span>
              <span>{{ detailsInfo.pay_time | dateFormat }}</span>
            </div>
          </div>
          <div class="item">
            <div class="title">
              <span>结算金额</span>
              <span>{{ detailsInfo.pay_sa_money }}</span>
            </div>
          </div>
          <div class="item">
            <div class="title">
              <span>交易单号</span>
              <span>{{ detailsInfo.trade_no }}</span>
            </div>
          </div>
        </div>
        <el-divider content-position="left">结算信息</el-divider>
        <div class="settle-info">
          <div class="item">
            <div class="title">
              <span>结算状态</span>
              <span>{{
                detailsInfo.settlement_status | settlement_statusText
              }}</span>
            </div>
          </div>

          <div class="item">
            <div class="title">
              <span>{{
                detailsInfo.settlement_status == 3 ? "结算账期" : "预计结算账期"
              }}</span>
              <span>{{ detailsInfo.period }} </span>
            </div>
          </div>

          <div v-if="detailsInfo.settlement_status == 3" class="item">
            <div class="title">
              <span>结算入账时间</span>
              <span>{{ detailsInfo.sa_time | dateFormat }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
      <script>
import dayjs from "dayjs";
import Pagination from "@/components/Pagination/index";
import doctor_fee from "@/api/doctor_fee";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      itemIdOption: [],
      searchForm: {
        settlement_status: "0",
        doctor_name: "",
        doctor_phone: "",
        user_phone: "",
        trade_no: "",
        item_id: "",
        pay_time: "",
        is_test: 0,
      },
      tableHeader: [
        {
          label: "支付时间",
          prop: "pay_time",
          width: "150px",
          align: "center",
          fixed: "left",
        },
        {
          label: "用户昵称",
          prop: "nick_name",
          width: "auto",
          align: "center",
          fixed: false,
        },

        {
          label: "用户手机号",
          prop: "user_phone",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "赠送人",
          prop: "user_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生姓名",
          prop: "doctor_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生手机号",
          prop: "doctor_phone",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "锦旗类型",
          prop: "silk_banner_title",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "赠送金额",
          prop: "pay_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "赠言",
          prop: "dedication",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "交易单号",
          prop: "trade_no",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "settlement_status",
          width: "110",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      info: {},
      detailsVisible: false,
      detailsInfo: {},
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatMM(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM");
    },
    settlement_statusText(val) {
      switch (Number(val)) {
        case 1:
          return "待系统核算";
        case 2:
          return "待结算";
        case 3:
          return "已结算";
      }
    },
    sexText(val) {
      switch (Number(val)) {
        case 1:
          return "男";
        case 2:
          return "女";
        case 0:
          return "未知";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
  },
  created() {
    this.initDate();
    this.getSilkMoneyList();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.searchForm.pay_time = [start, end];
    },
    getSilkMoneyList() {
      doctor_fee.getSilkMoneyList().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.itemIdOption = data.list;
        }
      });
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.searchForm);
      params = _.omit(params, ["reg_time"]);
      let times = this.searchForm.pay_time;
      params["pay_start_time"] = times ? times[0] : "";
      params["pay_end_time"] = times ? times[1] : "";
      this.tableLoading = true;
      doctor_fee
        .getSilkCostLog(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.tableData = data.list;
            this.info = data.info;
            this.totalNum = data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => (this.tableLoading = false));
    },
    seachEnterFun() {
      this.pagination.page = 1;
      this.getList();
    },

    lookBtn(row) {
      this.detailsInfo = row;
      this.detailsVisible = true;
    },
  },
};
</script>
      <style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.flag-record {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
.flag-record-dia {
  .user-info {
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin-bottom: 40px;
    .item {
      width: 200px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        span:first-child {
          margin-right: 10px;
          font-weight: bold;
        }
      }
    }
  }
  .el-divider__text {
    font-size: 16px;
    font-weight: bold;
  }
  .flag-info {
    display: flex;
    flex-wrap: wrap;
    padding-left: 20px;
    .item {
      display: flex;
      margin-right: 100px;
      margin-bottom: 20px;
      span:first-child {
        margin-right: 10px;
        font-weight: bold;
      }
    }
  }
  .pay-info {
    display: flex;
    flex-wrap: wrap;
    padding-left: 20px;
    .item {
      height: 30px;
      display: flex;
      margin-right: 60px;
      span:first-child {
        margin-right: 10px;
        font-weight: bold;
      }
    }
  }
  .settle-info {
    padding-left: 20px;
    .item {
      height: 30px;
      display: flex;
      span:first-child {
        margin-right: 10px;
        font-weight: bold;
      }
    }
  }
}
</style>
      